import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import Button from "../../../../FormElement/Button";
import Dropdown from "../../../../FormElement/Dropdown";
import InputFiled from "../../../../FormElement/InputFiled";


const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class CommVarietyForm extends Component {
  state = {};

  getLbsPerBushel = type => {
    const { commVar } = this.props;
    var selectedComm = commVar.filter(item => item.name == type);
    return selectedComm[0] ? selectedComm[0].lbsPerBushel : 0;
  };

  render() {
    const {
      commVarietyInfo,
      commVar,
      createCommVariety,
      buttonLabel,
      formLabel,
      isValid,
      handleChange,
      handleError,
      edited
    } = this.props;
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Dropdown
                value={commVarietyInfo.commodityType}
                label="Commodity Name"
                required
                type="text"
                options={commVar}
                name="commodityType"
                validations={["required"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>

            <Grid item xs={12}>
              <InputFiled
                label="Commodity Variety"
                value={commVarietyInfo.variety}
                required
                type="text"
                name="variety"
                validations={["required", "maxSize"]}
                handleChange={handleChange}
                handleError={handleError}
              />
            </Grid>

            <Grid item xs={12}>
              <InputFiled
                label="lbs Per Bushel"
                value={this.getLbsPerBushel(commVarietyInfo.commodityType)}
                type="text"
                name="lbsPerBushel"
                disabled
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link
              to="/farmsetup/farminformation/commodity-varieties"
              style={{ color: "blue" }}
            >
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isValid}
              onclick={createCommVariety}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CommVarietyForm;



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/CommodityVarietes/CommVarietyForm.js